import { View } from 'react-native';
import { Text } from 'react-native-paper';
import GoBackButton from '../components/goBackButton';
import { useAppTheme } from '../theme';
import EditBusinessForm from '../components/editBusinessForm';
import { Props } from '../types';

export default function EditScreen({ navigation }: Props) {
  const theme = useAppTheme();

  return (
    <View style={{ backgroundColor: theme.colors.background, flex: 1 }}>
      <GoBackButton />
      <Text style={{ paddingLeft: 15, fontSize: 24, fontWeight: '500' }}>
        Edit Business
      </Text>
      <EditBusinessForm navigation={navigation} />
    </View>
  );
}
